export default __webpack_public_path__ + "static/media/thumbsup.c9ae0748.svg";